module.exports = __webpack_public_path__ + "media/images/mailer-image-1-5c2123a53f52407cbcf22b230d6d8487.jpg";